import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MentionModule } from 'angular-mentions';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';

import { DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NgxEditorModule } from 'ngx-editor';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { HeaderComponent } from './layout/header/header.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { FooterComponent } from './layout/footer/footer.component';
import { PostReviewModelComponent } from './layout/post-review-model/post-review-model.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { CreateProfileComponent } from '../profile/create-profile/create-profile.component';
import { DynamicFieldsComponent } from '../profile/create-profile/dynamic-fields/dynamic-fields.component';

import { ShortenPipe } from '../core/pipes/sorten.pipe';

import { maxValidatorDirective } from '../core/validation/max.validator';
import { blankValidatorDirective } from '../core/validation/blank.validator';
import { dataTypeValidatorDirective } from '../core/validation/datatypeValidator';
import { SortByPipe } from '../core/pipes/SortByPipe.pipe';
import { AmpVideoComponent } from './amp-video/amp-video.component';
import { ImageOnlyDirective } from '../core/validation/imageOnly.validator';
import { NgxLinkifyjsHtmlPipe } from '../core/pipes/linkify-html.pipe';
import { LoaderComponent } from './loader/loader.component';
import { HelpBotComponent } from './help-bot/help-bot.component';
import { NoLeadingWhitespaceValidatorDirective } from '../core/validation/noleadingwhitespace';
import { NgxMaskModule } from 'ngx-mask';
import { RecaptchaV3Module } from 'ng-recaptcha';

import { StateCodePipe } from '../core/pipes/state-code.pipe';
import { ImageCropperModule } from 'ngx-image-cropper';
import { TagInputModule } from 'ngx-chips';
import {
  MultiSelectAllModule,
  MultiSelectModule,
} from '@syncfusion/ej2-angular-dropdowns';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { MobileContextBarComponent } from './layout/mobile-context-bar/mobile-context-bar.component';
import { CxIconComponent } from './icon/cx-icon.component';
import { PasswordVisibilityToggleDirective } from './password-visibility-toggle.directive';
import { CxModalDialogDirective } from './modal-dialog.directive';

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    PostReviewModelComponent,
    ThankyouComponent,
    CreateProfileComponent,
    DynamicFieldsComponent,
    maxValidatorDirective,
    blankValidatorDirective,
    dataTypeValidatorDirective,
    ImageOnlyDirective,
    ShortenPipe,
    SortByPipe,
    NgxLinkifyjsHtmlPipe,
    StateCodePipe,
    AmpVideoComponent,
    LoaderComponent,
    HelpBotComponent,
    NoLeadingWhitespaceValidatorDirective,
    MobileContextBarComponent,
    PasswordVisibilityToggleDirective,
    CxModalDialogDirective,
  ],
  providers: [DatePipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatProgressSpinnerModule,
    MentionModule,
    AutocompleteLibModule,

    DatePickerModule,
    ImageCropperModule, // ← add back (CreateProfileComponent uses it)
    TagInputModule, // ← add back (DynamicFieldsComponent uses it)
    MultiSelectAllModule, // ← add back (DynamicFieldsComponent uses it)
    MultiSelectModule, // ← add back
    NgxMaskModule,
    NgxEditorModule,
    RecaptchaV3Module,
    BsDatepickerModule.forRoot(),
    DragDropModule,
    CxIconComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatProgressSpinnerModule,
    MentionModule,
    AutocompleteLibModule,

    DatePickerModule,
    ImageCropperModule,
    TagInputModule,
    MultiSelectAllModule,
    MultiSelectModule,
    NgxEditorModule,
    HeaderComponent,
    SidebarComponent,
    FooterComponent,
    PostReviewModelComponent,
    ThankyouComponent,
    CreateProfileComponent,
    DynamicFieldsComponent,
    maxValidatorDirective,
    blankValidatorDirective,
    dataTypeValidatorDirective,
    ImageOnlyDirective,
    ShortenPipe,
    SortByPipe,
    NgxLinkifyjsHtmlPipe,
    StateCodePipe,
    AmpVideoComponent,
    LoaderComponent,
    HelpBotComponent,
    NoLeadingWhitespaceValidatorDirective,
    MobileContextBarComponent,
    PasswordVisibilityToggleDirective,
    CxModalDialogDirective,
    RecaptchaV3Module,
    BsDatepickerModule,
    DragDropModule,
    CxIconComponent,
  ],
})
export class SharedModule {}
